import requestAction from '../../utils/requestAction'
import ProductSubgroup from '../../models/ProductSubgroup';

export const upsertProductSubgroup = (productSubgroup: (ProductSubgroup)) =>
  requestAction('PRODUCTSUBGROUP_UPSERT')(
    `productSubgroups${(productSubgroup as ProductSubgroup).id ? `/${(productSubgroup as ProductSubgroup).id}` : ''}`,
    (productSubgroup as ProductSubgroup).id ? 'PUT' : 'POST',
    productSubgroup
  )
